import { QpShell } from "@qpds/shell";
import { QpElementsModule } from "@qpds/elements";

const startUp = async () => {
  const shell = new QpShell();

  shell.registerModule(QpElementsModule);

  await shell.configure();
  await shell.activate();
  await shell.run();
};

(async () => {
  await startUp();
})();
